/**
 * Toast plugin that works with both Oruga and Buefy
 *
 * Usage:
 * - In Vue component: this.$toast('Message', 'variant')
 * - With options: this.$toast({ message: 'Message', variant: 'success' })
 */

export default {
  install(app, options = {}) {
    const toast = (message, variant = 'light') => {
      // Handle both string and object syntax
      const params = typeof message === 'string'
        ? { message, variant }
        : { variant: 'light', ...message }

      // Default options
      const defaultOptions = {
        duration: 5000,
        position: 'top',
        queue: false,
        ...options,
      }

      // Oruga available
      if (app.config.globalProperties.$oruga) {
        const oruga = app.config.globalProperties.$oruga
        oruga.notification.open({
          message: params.message,
          rootClass: 'toast-notification',
          duration: defaultOptions.duration,
          position: defaultOptions.position,
          variant: params.variant || 'light',
          queue: defaultOptions.queue,
        })
      }
      // Buefy available
      else if (app.config.globalProperties.$buefy) {
        const type = params.variant === 'danger'
          ? 'is-danger'
          : params.variant === 'success'
          ? 'is-success'
          : params.variant === 'warning'
          ? 'is-warning'
          : 'is-light'

        app.config.globalProperties.$buefy.toast.open({
          message: params.message,
          type,
          duration: defaultOptions.duration,
          position: defaultOptions.position === 'top' ? 'is-top' : 'is-bottom',
          queue: defaultOptions.queue,
        })
      }
      // Fallback
      else {
        console.log(`[Toast ${params.variant}]:`, params.message)
      }
    }

    // Add $toast to the global properties
    app.config.globalProperties.$toast = toast

    // Expose globally so non-VM contexts (like utils.js) can delegate
    try {
      if (typeof globalThis !== 'undefined' && !globalThis.$toast) {
        globalThis.$toast = toast
      }
    } catch (_) {}

    // Provide for injection if needed
    app.provide('toast', toast)
  },
}
